import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 

let service = new services();
export default {
    name: 'Home',
    data () {
        return {
            header_data:{},
            user:{},
            collections:{},
            gigs:{},
            total_collection_balance:0,
            total_gigs_balance:0,
            app_collection_balance:0,
            loggedIn: false,
            loading: true,
            set_cashout_gig: false,
            tab_view: {},
            menu_tab_view:{},
            gigs_amount_to_cashout:0,
            gigs_cash_out_proc_fee:service.app_gigs_cash_out_proc_fee,
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        },

    },
    methods: {
        setComponent(attr1,attr2){
            if(attr1 == "reset-edit"){}
        },

        setTabComponent(view){
            this.tab_view = {};
            this.tab_view[view] =  true;
        },

        setMenuTabView(view,attr1,attr2){
            if(this.menu_tab_view[view] == true){//toggle reverse
                this.menu_tab_view = {};
                this.setComponent('reset-edit','');
            }else{
                this.setComponent('reset-edit','');
                this.menu_tab_view = {};
                this.menu_tab_view[view] = true;
            }
        },

        checkCashOutGigs(){
            this.gigs_amount_to_cashout = Number(this.gigs_amount_to_cashout);
            if(this.gigs_amount_to_cashout > this.gigs_collection_balance){
                this.gigs_amount_to_cashout = this.gigs_collection_balance;
            }
        },

        preset_xtra() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                           this.user.user_id = element.user_id;
                           this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, this);
                    }else {
                       //this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                    }
                })
            }else {
               //this.$router.push('login');
            }
        },

        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    //self.getCollections();
                    self.getMonies();
                    self.loading = false;
                }else {
                    self.$router.push('login');
                    // console.log(err)
                }
            });
        },
        
        getCollections(){
            service.getUserCollections(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.collections = response.body.data; 
                    this.collections_businesses = response.body.data_collections_businesses; 
                    this.total_collection_balance = response.body.data_total_balance; 
                    // this.gigs_collection_balance = response.body.data_gigs_collection_balance; 
                    // this.app_collection_balance = response.body.data_app_collection_balance; 
                    this.loading = false;
                }
            }).catch((err) => {})
        },

        getMonies(){
            service.getUserMonies(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    //collections
                    this.total_collection_balance = response.body.data_collection_total_balance	;
                    this.collections = response.body.data_collection_data; 

                    //gigs
                    this.total_gigs_balance = response.body.data_gigs_total_balance	;
                    this.gigs = response.body.data_gigs_data; 

                    // this.collections_businesses = response.body.data_collections_businesses; 
                    // this.total_collection_balance = response.body.data_total_balance; 
                    // // this.gigs_collection_balance = response.body.data_gigs_collection_balance; 
                    // // this.app_collection_balance = response.body.data_app_collection_balance; 
                    this.loading = false;
                }
            }).catch((err) => {})
        },

        cashOutGigs(){
            // this.activate_processing();
            var payload = {
                data_business: 0, //no business //simply //cashout
                data_type: 29, //gisgs cashout
                data_user: this.user.user_id,
                data_amount_paid: this.gigs_amount_to_cashout,
                data_action_type: 7, //collections deduct
                data_module: 0, //none
                data_module_id: 0, //none
                data_module_order_service_payment_ref: "", //none
            }
            if(payload.data_amount_paid == 0){
                this.data_processing_message = "Amount should be more than 0";
                // this.deactivate_processing();
            }else{
                service.postCollectionsServices(this, payload).then(function(response) {
                    if((response.body.status == 201) || (response.body.status == 200)) {
                        this.getCollections();
                        // this.collections = response.body.data; 
                        // this.collections_businesses = response.body.data_collections_businesses; 
                        // this.total_collection_balance = response.body.data_total_balance; 
                        // this.gigs_collection_balance = response.body.data_gigs_collection_balance; 
                        // this.app_collection_balance = response.body.data_app_collection_balance; 
                        //
                        this.gigs_amount_to_cashout = 0;
                    }
                }).catch((err) => {
                    //log it
                    this.gigs_amount_to_cashout = 0;
                    // this.deactivate_processing();
                })
            }
        }
        
    },
    created: function(){
        this.preset();
        this.setTabComponent('tab02');
        this.header_data.name = "Collections";
    }
}


// WEBPACK FOOTER //
// ./src/pages/Collections/script.js